/**
 * usePageTracking Hook
 *
 * Automatically tracks page views when routes change.
 * Integrates with React Router and Google Analytics.
 *
 * Usage:
 * In App.jsx or any top-level component:
 *
 * function App() {
 *   usePageTracking(); // That's it!
 *   return <Routes>...</Routes>;
 * }
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/AnalyticsService';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip if analytics not ready
    if (!analyticsService.isReady()) {
      return;
    }

    // Build full page path (HashRouter includes hash in pathname)
    const page = location.pathname + location.search + location.hash;

    // Get page title from document
    const title = document.title;

    // Track page view
    analyticsService.trackPageView(page, title);

  }, [location]); // Re-run when location changes
};

export default usePageTracking;
